import { render, staticRenderFns } from "./TopicsComponent.vue?vue&type=template&id=5d5c4706&scoped=true&"
import script from "./TopicsComponent.vue?vue&type=script&lang=js&"
export * from "./TopicsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopicsComponent.vue?vue&type=style&index=0&id=5d5c4706&lang=scss&scoped=true&"
import style1 from "./TopicsComponent.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./TopicsComponent.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c4706",
  null
  
)

export default component.exports